import CakeIcon from '../../../Icons/Cake';
import MailIcon from '../../../Icons/Mail';
import PhoneIcon from '../../../Icons/Phone';
import LocationIcon from '../../../Icons/Location';
import { DirectionsBike, TwoWheeler } from '@material-ui/icons';
import { formatPhoneNumber } from 'react-phone-number-input';
import { differenceInYears } from 'date-fns';
import {
  getProfilePresentation,
} from '@webapps/business';
import {
  useAuth,
  useQuery,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import '../../../Montserrat-Regular-normal'
import BikeIcon from 'components/Icons/BikeIcon';
import DirectionsCar from 'components/Icons/DirectionsCarIcon';
import DirectionsBus from 'components/Icons/DirectionsBus';
import Motorcycle from 'components/Icons/Motorcycle';


const ClassiqueCopyHeader = ({ htmlStaticStyle, transportsSelected, contentHeaderRef, info }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const currentDate = new Date();
  const { idUser: id } = useAuth();

  const {
    data: { presentation = '', completeRate } = {},
  } = useQuery(getProfilePresentation, {
    key: 'studentDescription',
    variables: { id },
  });

  const transportInfos = (value, dark) => {
    switch (value) {
      case 'T1':
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <BikeIcon
              style={{
                marginRight: spacing(1),
                width: 20,
                fill: dark ? '#000000' : '#FFFFFF',
                height: 20,
              }}
            />
            {/* <div>Trottinette</div> */}
          </div>
        );
      case 'T2':
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <DirectionsCar
              style={{
                marginRight: spacing(1), width: 20, color: dark ? '#000000' : '#FFFFFF',
                fill: dark ? '#000000' : '#FFFFFF',
              }}
            />
            {/* <div>Voiture</div> */}
          </div>
        );
      case 'T3':
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Motorcycle
              style={{
                marginRight: spacing(1), width: 20, color: dark ? '#000000' : '#FFFFFF',
                fill: dark ? '#000000' : '#FFFFFF',
              }}
            />
            {/* <div>Scooter</div> */}
          </div>
        );
      case 'T4':
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <TwoWheeler
              style={{
                marginRight: spacing(1), width: 20, color: dark ? '#000000' : '#FFFFFF',
                fill: dark ? '#000000' : '#FFFFFF',

              }}
            />
            {/* <div>Moto</div> */}
          </div>
        );
      case 'T5':
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <DirectionsBus
              style={{
                marginRight: spacing(1), width: 20, color: dark ? '#000000' : '#FFFFFF',
                fill: dark ? '#000000' : '#FFFFFF',

              }}
            />
            {/* <div>Transports</div> */}
          </div>
        );
      case 'T6':
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <DirectionsBike
              style={{
                marginRight: spacing(1), width: 20, color: dark ? '#000000' : '#FFFFFF',
                fill: dark ? '#000000' : '#FFFFFF',

              }}
            />
            {/* <div>Vélo</div> */}
          </div>
        );
    }
  };

  return (
    <div style={htmlStaticStyle.header} ref={contentHeaderRef}>
      <h1 style={htmlStaticStyle.mergeStyle(htmlStaticStyle.title, htmlStaticStyle.name)}>
        {info?.firstname} {info?.lastname}
      </h1>
    </div>
  );
};

const styles = () => ({

});

export default ClassiqueCopyHeader;